const SEGMENTATION_LUNG_TYPES = {
  left: { key: 'left', name: 'left' },
  right: { key: 'right', name: 'right' },
};

export default SEGMENTATION_LUNG_TYPES;
